import Vue from 'vue';
import Router from 'vue-router';

import Home from './views/Home.vue';
import Success from './views/Success.vue';
import Error from './views/Error.vue';
import AlreadyPaid from './views/AlreadyPaid.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/success',
      name: 'success',
      component: Success,
    },
    {
      path: '/error',
      name: 'error',
      component: Error,
    },
    {
      path: '/already-paid',
      name: 'already-paid',
      component: AlreadyPaid,
    },
    {
      path: '**',
      redirect: '/'
    }
  ],
});

// router.beforeEach(async (to, from, next) => {
//   const { paymentId } = to.query;
//   if (paymentId) {
//     next();
//   } else {
//     window.location.replace(ENV.APP_FALLBACK_URL);
//   }
// });
//
// router.afterEach((to) => {
//   const NO_REDIRECT_ROUTES = ['home', 'error', 'dummy', 'success'];
//   if (!NO_REDIRECT_ROUTES.includes(String(to.name))) {
//     setTimeout(() => {
//       window.location.replace(ENV.APP_FALLBACK_URL);
//     }, 10000);
//   }
// });

export default router;
